import { DiscoverQueryParams } from '@src/common/enums';
import { getSearchParams } from '@src/utils/query-string';
import { useEffect, useMemo, useState } from 'react';
import { useOnlineEU } from './use-online-eu';

/**
 * check the gdpr from search params, if gdrp is not specified in url search params, then will use the online EU
 * @returns true/false/undeined, if value is undefined, it means EU value is loading
 */
export function useEU(): boolean | undefined {
    //default value is undefined , means EU value is loading
    const [gdprURLParam, setGdprURLParam] = useState<'0' | '1' | null>();
    useEffect(() => {
        const searchParams = getSearchParams();
        const gdpr = searchParams.get(DiscoverQueryParams.gdpr);
        if (gdpr === '1') {
            setGdprURLParam('1');
        } else if (gdpr === '0') {
            setGdprURLParam('0');
        } else {
            setGdprURLParam(null);
        }
    }, []);

    const onlineEU = useOnlineEU(gdprURLParam === null);
    const isEU = useMemo(() => {
        if (gdprURLParam === undefined) {
            return undefined; //means loading
        } else if (gdprURLParam === null) {
            return onlineEU;
        } else if (gdprURLParam === '0') {
            return true;
        } else {
            return false;
        }
    }, [gdprURLParam, onlineEU]);
    return isEU;
}
